// Don't add new routes to this file. Split off into [section].route.js.

export const OCRoutes = [
  {
    path: 'profile',
    name: 'profile',
    component: () => import('@/views/User/Profile.vue'),
    meta: {
      customName: 'views.profile.title',
    }
  },
];
